import { useState } from 'react';

function useToggle<TParamState>({ initial } = { initial: false }) {
    const [isOpen, setOpen] = useState(initial);
    const [params, setParams] = useState<TParamState>(null);

    const toggle = () => setOpen((prevState) => !prevState);
    return {
        isOpen,
        toggle,
        params,
        setParams
    };
}

export default useToggle;
